"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueList = void 0;
const core_1 = require("@material-ui/core");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const makeMyClasses = (disabled, noBorder, right) => ({
    root: {
        position: 'relative',
        cursor: disabled ? undefined : 'pointer',
        pointerEvents: disabled ? 'none' : 'unset',
        borderRadius: 4,
        border: noBorder ? '0 !important' : `1px solid ${lib_palette_1.default.InputBorderGrey.main}`,
        opacity: disabled ? 0.7 : undefined,
        backgroundColor: lib_palette_1.default.White.main,
        textAlign: right ? 'right' : undefined,
        paddingLeft: 4,
        minHeight: 44,
    },
    inner: {
        minHeight: 44,
    },
    number: {
        position: 'absolute',
        right: 0,
        borderRadius: '16px 0 0 16px',
        padding: '8px 12px',
        minWidth: 0,
    },
});
exports.ValueList = react_1.default.forwardRef((props, ref) => {
    const { classes, value, onClick, 
    // onChange,
    transparentLabel = false, noBorder = false, alwaysWrap = false, allSelectable = false, allSelected = false, 
    // required = false,
    tooltip, disabled = false, right = false, hideSelectButton = false, 
    // allSelectedLabel,
    label = lib_i18n_1.default.t('select'), 
    // onRemoveAllSelected,
    renderAll, renderValue, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [disabled, noBorder, right], classes);
    const [flexWrap, setFlexWrap] = (0, react_1.useState)(alwaysWrap ? 'wrap' : 'nowrap');
    const selectedPills = (0, react_1.useRef)(null);
    const isAllSelected = allSelectable && allSelected;
    const isValueSelected = !isAllSelected && !!(value === null || value === void 0 ? void 0 : value.length);
    const isNothingSelected = !isAllSelected && !isValueSelected;
    const isOverflown = r => {
        return (r === null || r === void 0 ? void 0 : r.current) && r.current.scrollWidth > r.current.offsetWidth;
    };
    const [showNumber, setShowNumber] = (0, react_1.useState)(flexWrap === 'nowrap' && isOverflown(selectedPills));
    (0, react_1.useEffect)(() => {
        setShowNumber(flexWrap && flexWrap === 'nowrap' && isOverflown(selectedPills));
    }, [flexWrap, value]);
    const handleClickAway = (0, react_1.useCallback)(e => {
        if (!alwaysWrap) {
            e.stopPropagation();
            setFlexWrap('nowrap');
        }
    }, [alwaysWrap]);
    const handleClickExpand = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        setFlexWrap('wrap');
    }, []);
    return (react_1.default.createElement(core_1.ClickAwayListener, { onClickAway: handleClickAway },
        react_1.default.createElement("div", { className: myCss.root, onClick: onClick, ref: ref },
            react_1.default.createElement(Horizontal_1.default, { centered: true },
                !!right && react_1.default.createElement(Pane_1.default, { grow: true }),
                react_1.default.createElement("div", { ref: selectedPills, style: { overflow: 'hidden' } },
                    react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.inner }, gutter: true, shrink: true, centered: true, justify: 'flex-start', flexWrap: flexWrap },
                        isAllSelected && renderAll(),
                        isValueSelected && value.filter(v => !!v).map(renderValue),
                        isNothingSelected && !hideSelectButton && (react_1.default.createElement(Button_1.default, { disabled: disabled, small: true, background: transparentLabel ? 'transparent' : undefined, color: lib_palette_1.default.secondary, label: label, tooltip: tooltip })))),
                showNumber && (react_1.default.createElement(Button_1.default, { small: true, classes: { root: myCss.number }, color: lib_palette_1.default.secondary, onClick: handleClickExpand, label: '' + value.length }))))));
});
exports.default = exports.ValueList;
